import React, { forwardRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadControllersPage, reset } from "./employeeHouseVisitsSlice";

import VisitsTable from "./components/VisitsTable";

const ControllersVisits = forwardRef((props, ref) => {
  const { activeTab } = props;
  const dispatch = useDispatch();

  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );

  const { controllersPage: houseVisitsPage, activeMonth } = useSelector(
    (state) => state.employeeHouseVisits
  );
  const { items } = houseVisitsPage;

  const loading = useSelector(
    (state) => state.pendingActions["employeeHouseVisits/loadControllersPage"]
  );

  useEffect(() => {
    if (activeTab) {
      dispatch(reset());
    }
  }, [activeTab, dispatch]);

  useEffect(() => {
    if (activeEmployee.id && activeTab === "controllers_visits") {
      dispatch(loadControllersPage());
    }
  }, [dispatch, activeEmployee.id, activeMonth, activeTab]);

  return (
    <VisitsTable
      items={items}
      loading={loading}
      activeTab={activeTab}
      loadPage={loadControllersPage}
    />
  );
});

export default ControllersVisits;
